import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat } from '@fortawesome/sharp-solid-svg-icons/faRepeat';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import style from './cost-review-rate-recommendation-banner.module.less';
import { messages } from './messages';
import { RateRecommendationBanner } from '../../../fulfillment-planner/rate-recommendation/recommendation/rate-recommendation-banner';
import FormattedCurrency from '../../formatted-currency';

/**
 * @typedef {import('../../../prop-types/currency')} Currency
 */

/**
 * @param {object} props
 * @param {boolean} props.isApplyingRecommendations
 * @param {Currency} props.totalAppliedSavings
 * @param {Currency} props.totalRecommendationSavings
 * @param {() => void} props.selectAllRecommendations
 * @returns {React.JSX.Element}
 */
export const CostReviewRecommendationBanner = ({
  isApplyingRecommendations,
  totalAppliedSavings,
  totalRecommendationSavings,
  selectAllRecommendations,
}) => {
  const shouldShowBanner = totalRecommendationSavings?.value || totalAppliedSavings?.value || isApplyingRecommendations;
  if (!shouldShowBanner) {
    return null;
  }

  const applyButton = (
    <Button className={style['apply-button']} onClick={selectAllRecommendations} theme='white'>
      <FontAwesomeIcon className={style['apply-button-icon']} icon={faRepeat} />
      <FormattedMessage {...messages.applyToAll} />
    </Button>
  );

  const bannerText = (
    <Text
      className={style['banner-text']}
      formattedMessageValues={{
        savingsAmount: (
          <FormattedCurrency currencyCode={totalRecommendationSavings?.currency} value={totalRecommendationSavings?.value || 0} />
        ),
        bold: (chunks) => <Text element='span' textType={TextType.H3} value={chunks} />,
      }}
      textType={TextType.Paragraph}
      value={messages.totalRecommendationSavings}
    />
  );

  return (
    <RateRecommendationBanner
      appliedSavings={totalAppliedSavings}
      applyButton={applyButton}
      bannerText={bannerText}
      contentClassName={style['banner-content']}
      isApplyingSavings={isApplyingRecommendations}
      theme={totalAppliedSavings?.value ? 'light' : 'medium'}
    />
  );
};
